var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3813 3.60657C30.2063 2.78153 30.2063 1.44384 29.3813 0.618798C28.5562 -0.206266 27.2185 -0.206266 26.3935 0.618798L15 12.0123L3.60657 0.618798C2.78153 -0.206266 1.44384 -0.206266 0.618798 0.618798C-0.206266 1.44384 -0.206266 2.78153 0.618798 3.60657L12.0123 15L0.618798 26.3935C-0.206266 27.2185 -0.206266 28.5562 0.618798 29.3813C1.44384 30.2063 2.78153 30.2063 3.60657 29.3813L15 17.9878L26.3935 29.3813C27.2185 30.2063 28.5562 30.2063 29.3813 29.3813C30.2063 28.5562 30.2063 27.2185 29.3813 26.3935L17.9878 15L29.3813 3.60657Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.53adf778ca58de6a1fd990b8e2ae7ada.svg";
export { ForwardRef as ReactComponent };